"use strict";

($dt => {

	const controller = {
		elem: false,
		open: false,

		Ready: () => {
			// Init Overlay Element
			if (controller.elem === false) {
				const overlay = document.getElementById('site-overlay');

				// Background and other close element clicks
				overlay.addEventListener('click', e => {
					const target = e.target;
	
					// Only cancel on clicks to items that aren't the actual content (like a video or image)
					// Can add things like close buttons to this if condition
					if (target.classList.contains('overlay-fill') || target.classList.contains('overlay-close')) {
						e.preventDefault();
						controller.Close();
					}
				});

				controller.elem = overlay;
			}

			return controller.elem;
		},

		InitSoloVideoCTAs: () => {
			const clickers = document.querySelectorAll('[data-solo-video-url]');

			clickers.forEach(elem => {

				// Get video information based on URL
				const video = $dt.Util.getVideoDataBasedOnUrl(elem.getAttribute('data-solo-video-url'));

				// Happens on before animation started (async)
				const pre_animate = overlay => {
					// Append iframe URL to overlay content area
					const content_elem = overlay.querySelector('.overlay-content');
					content_elem.innerHTML = video.get_iframe();
				};

				// Happens after delay before content animation begins (async)
				const open_complete = () => {
					
				};

				elem.addEventListener('click', () => {
					controller.Open(pre_animate, open_complete);
				});
			});
		},

		Open: (on_pre_animate, on_open_complete) => {
			// Call ready for lazy loading
			const overlay = controller.Ready();

			overlay.classList.add('overlay-active');
			document.body.classList.add('no-scroll-active');

			setTimeout(() => {
				overlay.classList.add('overlay-visible');

				if (typeof(on_open_complete) !== 'undefined') {
					on_open_complete(overlay);
				}
			}, 100);

			if (typeof(on_pre_animate) !== 'undefined') {
				on_pre_animate(overlay);
			}
		},

		Close: () => {
			// Call ready for lazy loading
			const overlay = controller.Ready();

			overlay.classList.remove('overlay-visible');
			setTimeout(() => {
				overlay.classList.remove('overlay-active', 'overlay-full');
				overlay.querySelector('.overlay-content').innerHTML = '';
				document.body.classList.remove('no-scroll-active');
			}, 510);

		}
	};
	
	$dt.Overlay = controller;
	$dt.autostart.push(controller.InitSoloVideoCTAs);
	
})(window.d3_wp_themejs);
